export default "__VITE_ASSET__CwUTrlqN__"